import React from "react";
import Icon from "../../../components/AppIcon";

const B2BDisplay = ({ order }) => {
// Home Collection
  if (order.isHomeSample) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex-shrink-0">
          <div className="w-7 h-7 bg-gradient-to-br from-green-100 to-emerald-100 rounded-lg flex items-center justify-center">
            <Icon name="Home" size={14} className="text-emerald-600" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className="text-xs font-medium text-gray-900">Home Collection</span>
            {order.address && (
              <>
                <span className="text-gray-300">•</span>
                <span className="text-xs text-gray-500 truncate" title={order.address.address}>
                  {order.address.address}, {order.address.city}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Center Visit
  return (
    <div className="space-y-2">
      {order.center && (
        <div className="flex items-start gap-2">
          <div className="flex-shrink-0">
            <div className="w-7 h-7 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg flex items-center justify-center border border-blue-100">
              <Icon name="Building2" size={14} className="text-blue-600" />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5 flex-wrap">
              <span className="text-xs font-medium text-gray-900 truncate" title={order.center.name}>
                {order.center.name}
              </span>
            </div>
            {order.center.address && (
              <p className="text-[10px] text-gray-500 mt-0.5 truncate" title={order.center.address}>
                {order.center.address}
              </p>
            )}
          </div>
        </div>
      )}

      {/* No center assigned */}
      {!order.center && !order.diagnosticCenter && !order.isHomeSample && (
        <div className="flex items-center gap-2">
          <div className="flex-shrink-0">
            <div className="w-7 h-7 bg-gray-100 rounded-lg flex items-center justify-center">
              <Icon name="AlertCircle" size={14} className="text-gray-400" />
            </div>
          </div>
          <span className="text-xs text-gray-400 italic">No center assigned</span>
        </div>
      )}
    </div>
  );
};

export default B2BDisplay;